module.exports = __webpack_public_path__ + "img/comment.11bfd5b9.svg";